import React from 'react';

const Header = () => {
  return (
    <header className="w-full flex flex-col items-center gap-4 mb-5">
      <h1 className="text-5xl text-center max-md:text-3xl font-bold">La mejor App de Pronósticos Online</h1>
      <p className="text-2xl max-md:text-lg text-center">
        Vive la emoción del casino online desde tu dispositivo favorito con nuestra aplicación. Descárgala para disfrutar de las mejores ligas, torneos, tragamonedas, Live Casino y mucho más.
      </p>
    </header>
  );
};

export default Header;
